import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=588ed77b&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=588ed77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ed77b",
  null
  
)

export default component.exports